module.exports = __webpack_public_path__ + "static/img/1_0046.72f67c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0046.jpg
// module id = 1ssj
// module chunks = 0